export const INSTANT_BOOKING_TYPE = 'instantBooking';

export const CANCELLATION_POLICY_FLEXIBLE = 'flexible';
export const CANCELLATION_POLICY_MODERATE = 'moderate';
export const CANCELLATION_POLICY_STRICT = 'strict';